// extracted by mini-css-extract-plugin
export default {"layoutsidebar":"LayoutSidebar_layoutsidebar__x6Krp"};